import AssignmentSharingTableContainer from './AssignmentSharingTableContainer';

export default AssignmentSharingTableContainer;
